import React from 'react'
import './styles.scss'

interface SelectProps {
  name?: string
  list?: Array<any>
  disabled?: boolean
  styles?: any
  defaultValue?: string | number
  placeholder?: string
  onChange?: any
  value?: any
}

const defaultProps: SelectProps = {
  name: '',
  list: [],
  disabled: false,
  styles: {},
  defaultValue: '',
  placeholder: '',
  onChange: () => {},
  value: '',
}

const Select: React.FunctionComponent<SelectProps> = ({
  name,
  list,
  disabled,
  styles,
  defaultValue,
  onChange,
  placeholder,
  value,
}) => {
  return (
    <div id="select-container" style={styles}>
      <select
        name={name}
        className="select"
        disabled={disabled}
        defaultValue={defaultValue}
        onChange={onChange}
        value={value}
      >
        <option selected disabled>
          {placeholder}
        </option>
        {list?.map((item, index) => (
          <option value={item.value ? item.value : item} key={Number(index)}>
            {item.label ? item.label : item.value ? item.value : item}
          </option>
        ))}
      </select>
    </div>
  )
}

Select.defaultProps = defaultProps

export default Select
